import * as React from "react";

import { addDays, format, startOfWeek } from "date-fns";
import { Table } from "semantic-ui-react";

/** Return array of week day names.
 *
 * getWeekDays() --> ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Su']
 */
const getWeekDays = (localization?: string) => {
  const weekDays: string[] = [];
  let day = startOfWeek(new Date());
  for (let i = 0; i < 7; i++) {
    weekDays[i] = format(day, "EE");
    day = addDays(day, 1);
  }

  return weekDays;
};

const cellStyle = {
  border: "none",
  borderBottom: "1px solid rgba(34,36,38,.1)",
};

const getWeekDayCells = (localization?: string) =>
  getWeekDays(localization).map((weekDay) => (
    <Table.HeaderCell key={weekDay} style={cellStyle} colSpan="1">
      {weekDay}
    </Table.HeaderCell>
  ));

export interface HeaderWeeksProps {
  /** Moment date localization */
  localization?: string;
}

function HeaderWeeks(props: HeaderWeeksProps) {
  const { localization } = props;

  return <Table.Row>{getWeekDayCells(localization)}</Table.Row>;
}

export default HeaderWeeks;
